<template>
  <div class="t-card">
    <div v-if="pagination">
      <h5 class="t-card--number">
        <div>{{ pagination.totalDocs }}</div>
        <div class="t-card--small-text" style="margin-bottom: 1rem; ">
          <router-link to="/question-set" tag="span">
            <span class="hand highlight-text">{{ $t("common.view-all") }}</span>
          </router-link>
        </div>
      </h5>
      <div class="t-card--small-text" style="margin-bottom: 1rem;">{{ $t("question-set.will-be-answered") }}</div>
      <div class="progress-field">
        <div class="d-flex justify-content-between">
          <div class="progress-field--number">{{ pagination.answeredQuestionSets }} {{ $t("question-set.answered") }}</div>
          <div class="progress-field--percent">{{ completionRate }} %</div>
        </div>
        <div class="progress-field--progress-bar">
          <div class="progress-field--bar" :style="{ width: completionRate + '%' }"></div>
        </div>
      </div>
    </div>
    <div v-if="pagination">
      <div class="search--input-container mb-3">
        <i class="search--icon iconoir-search"></i>
        <input class="search--input" type="text" v-model="nameFilter" :placeholder="$t('question-set.search')" />
      </div>
      <div v-if="pagination">
        <div v-for="questionSet in pagination.docs" @click="redirectQuestionSet(questionSet)" :key="questionSet._id">
          <question-set-card class="hand" :questionSet="questionSet" />
        </div>
      </div>
      <empty width="100px" v-if="!isLoading && (!pagination || pagination.docs.length == 0)">
        <h5 class="text-center" id="myText">
          {{ $t("question-set.empty") }}
        </h5>
      </empty>
      <div class="d-flex mt-auto">
        <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="4" size="sm"></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionSetCard from "./question-set-card.vue";

export default {
  components: { QuestionSetCard },

  data() {
    return {
      nameFilter: undefined,
      request: {
        options: { page: 1, limit: 4, sort: { name: "asc" } },
        query: {},
      },
    };
  },

  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    nameFilter(n, o) {
      const localizedField = "name." + this.currentLanguage;
      if (n) {
        this.request.query = { ...this.request.query, [localizedField]: { value: n } };
      } else {
        this.request.query[localizedField] = null;
        delete this.request.query[localizedField];
      }
    },
  },

  computed: {
    pagination() {
      return this.$store.getters["organizationQuestionSet/myQuestionSetsPagination"];
    },
    isLoading() {
      return this.$store.getters[`organizationQuestionSet/isMyQuestionSetsLoading`];
    },

    completionRate() {
      return this.pagination.totalQuestionSets == 0 ? 0 : Math.floor((this.pagination.answeredQuestionSets / this.pagination.totalQuestionSets) * 100);
    },
  },

  methods: {
    async paginate() {
      await this.$store.dispatch("organizationQuestionSet/fetchCurrentUserAssignedQuestionSet", {
        ...this.request,
        query: { ...this.request.query, unAnswered: { value: true, isObject: true } },
      });
    },
    async redirectQuestionSet(questionSet) {
      // window.location.href = `/question-set/answering/${questionSet._id}`;

      const path = `/question-set/answering/${questionSet._id}`;
      this.selectOrganizationAndGo(questionSet.organization, path, false);
    },
  },
};
</script>

<style lang="scss" scoped>
.highlight-text {
  &:hover {
    color: black;
    font-weight: 500;
  }
}
</style>
